import React, { useEffect, useState } from 'react';
import { Loader } from '../../../../components/Loader/Loader';

import '../Widget.scss';
import { useFetchWarehouseOrders } from '../../../../hooks/useFetchWarehouseOrders';
import { ReqEnum } from '../../../../const/requestStatus';
import dayjs from 'dayjs';
import { DailyDeliveryOrdersSummary } from '../../../../types/statsTypes';
import { fetchDeliveryOrdersSummary } from '../../../../fetch/fetchStats';
import { MdExpandMore } from 'react-icons/md';
import { AccordionComponent } from '../../../../ReusableComponents/Accordion/AccordionComponent';

function NrOfWarehouseOrders() {
  const [orders, status] = useFetchWarehouseOrders();

  if (status !== ReqEnum.SUCCESS) {
    return <Loader />;
  }

  return (
    <div className="widget__accordion__warehouse">
      <span>Nr of warehouse orders:</span>
      <span>{orders.length}</span>
    </div>
  );
}

export default function FutureOrdersWidget(): JSX.Element {
  const [isLoading, setIsLoading] = useState(true);
  const [futureDeliveryOrders, setFutureDeliveryOrders] =
    useState<DailyDeliveryOrdersSummary>(null);
  const [expanded, setExpanded] = React.useState<string | false>('panel1');

  const handleChange =
    (panel: string | false) =>
    (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  useEffect(() => {
    const fetchDailyDeliveryWindowsCount = async () => {
      setIsLoading(true);

      const start = dayjs().add(1, 'day');
      const end = start.add(30, 'day');
      const deliveryOrders = await fetchDeliveryOrdersSummary(start, end);

      setFutureDeliveryOrders(deliveryOrders);
      setIsLoading(false);
    };

    fetchDailyDeliveryWindowsCount();
  }, []);

  if (isLoading) {
    return (
      <div className="widget">
        <div className="widget__header">
          <h5>Future orders</h5>
        </div>
        <div className="widget__loader">
          <Loader type="spinner" size="large" />
        </div>
      </div>
    );
  }

  const createAccordionFutureOrdersWidgetList = () => {
    const accordionArray = [];
    const numberOfXlOrders = futureDeliveryOrders.ordersSizeCount.xxl;
    const numberOfDeviatedBundledOrders =
      futureDeliveryOrders.ordersBundlesCount.openBundledDeviationCount;

    const numberOfUnbundledDeviatedOrders =
      futureDeliveryOrders.ordersBundlesCount.openDeviationCount -
      numberOfDeviatedBundledOrders;
    const numberOfRegularOrders =
      futureDeliveryOrders.ordersSizeCount.dailyTotal -
      numberOfUnbundledDeviatedOrders;
    const numberOfTemperatureOrders =
      futureDeliveryOrders.ordersSizeCount.temperatureCount;
    const numberOfUnbundledOrders =
      futureDeliveryOrders.ordersSizeCount.dailyTotal -
      futureDeliveryOrders.ordersBundlesCount.bundleCount;
    const numberOfBundledOrders =
      futureDeliveryOrders.ordersBundlesCount.bundleCount -
      numberOfDeviatedBundledOrders;
    if (futureDeliveryOrders) {
      const accordionOrdersObject = {
        expandIcon: <MdExpandMore />,
        expanded: expanded === 'panel1',
        onChange: handleChange('panel1'),
        accordionSummary: {
          element: (
            <div className="widget__accordion__header">
              <span>Orders</span>
              <span>{numberOfRegularOrders}</span>
            </div>
          ),
          className: '',
        },
        accordionDetails: {
          className: 'widget__accordion__details',
          element: (
            <div>
              <div className="widget__accordion__details__text">
                <span>Regular:</span>
                <span>{numberOfRegularOrders}</span>
              </div>
              <div className="widget__accordion__details__text">
                <span>XL:</span>
                <span>{numberOfXlOrders}</span>
              </div>
              <div className="widget__accordion__details__text">
                <span>Temperature:</span>
                <span>{numberOfTemperatureOrders}</span>
              </div>
              <div className="widget__accordion__details__text">
                <span>Unbundled deviations:</span>
                <span>{numberOfUnbundledDeviatedOrders}</span>
              </div>
            </div>
          ),
        },
      };
      accordionArray.push(accordionOrdersObject);
      const accordionBundlesObject = {
        expanded: expanded === 'panel2',
        onChange: handleChange('panel2'),
        expandIcon: <MdExpandMore />,
        accordionSummary: {
          element: (
            <div className="widget__accordion__header">
              <span>Bundled orders</span>
              <span>{numberOfBundledOrders}</span>
            </div>
          ),
          className: '',
        },
        accordionDetails: {
          className: 'widget__accordion__details',
          element: (
            <div>
              <div className="widget__accordion__details__text">
                <span>Bundled:</span>
                <span>{numberOfBundledOrders}</span>
              </div>
              <div className="widget__accordion__details__text">
                <span>Bundled deviations:</span>
                <span>{numberOfDeviatedBundledOrders}</span>
              </div>
            </div>
          ),
        },
      };
      accordionArray.push(accordionBundlesObject);
      const accordionNotBundledNumber = {
        expanded: expanded === 'panel3',
        onChange: handleChange('panel3'),
        expandIcon: <MdExpandMore />,
        accordionSummary: {
          element: (
            <div className="widget__accordion__header">
              <div>Not bundled orders</div>
              <div>{numberOfUnbundledOrders}</div>
            </div>
          ),
          className: '',
        },
        accordionDetails: {
          className: '',
        },
      };
      accordionArray.push(accordionNotBundledNumber);
    }
    return accordionArray;
  };

  return (
    <div className="widget">
      <div className="widget__header__order_stats">
        <h5>FUTURE</h5>
      </div>
      <div style={{ height: 10 }} />
      <div className="widget__accordion">
        <AccordionComponent
          accordionDataList={createAccordionFutureOrdersWidgetList()}
        />
      </div>
      <div style={{ height: 10 }} />
      <NrOfWarehouseOrders />
    </div>
  );
}
